<template>
<div class="chapter">
<div class="inner_page">
<h1 class="P_Heading_1" id="auto_bookmark_toc_1"><span>Le sauveteur</span></h1>
<p class="P_Normal"> </p>
<p class="P_Norm-NoIndent">Par Rhys Ford</p>
<p class="P_Norm-NoIndent">Série 415 Ink, tome 2</p>
<p class="P_Normal"> </p>
<p class="P_Normal">Dans tout homme bon, il y a un sauveteur, mais parfois, c’est l’amour qui réveille l’homme dans le sauveteur.</p>
<p class="P_Normal">Mace Crawford, sapeur-pompier de San Francisco, a connu une enfance difficile. Enlevé par nécessité à son épouvantable père, il a été élevé dans le système fédéral, froid et indifférent. Devenu adulte, il consacre sa vie à sauver les autres, y compris les frères qu’il s’est choisis. Second de sa brigade, Mace guide ceux qui sont sous ses ordres ; à 415 Ink, le salon de tatouage familial, il apporte son aide, mais par-dessus tout, il protège sa famille de son secret le plus sombre.</p>
<p class="P_Normal">Alors qu’il s’est juré de ne jamais aimer, un gros problème apparaît dans sa vie solitaire : Rob Claussen, un des tatoueurs de 415 Ink, l’obsède de plus en plus.</p>
<p class="P_Normal">Mace a édifié de strictes frontières pour protéger son univers contrôlé – et son cœur, mieux barricadé encore. Il ne peut y faire entrer Rob, il ne peut céder à son désir sans risquer d’abattre les fondations mêmes de l’existence qu’il s’est bâtie.</p>
<p class="P_Normal">Un jour pourtant, un démon du passé refait surface et Mace est alors confronté à un choix : s’accrocher à ses mensonges ou sauver celui qu’il a si peur d’aimer.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0002.vue?cd9ab5ea